'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentType = exports.timeType = exports.fillModeType = exports.directionType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var directionType = exports.directionType = _propTypes2.default.oneOf(['normal', 'reverse', 'alternate', 'alternate-reverse']);

var fillModeType = exports.fillModeType = _propTypes2.default.oneOf(['none', 'forwards', 'backwards', 'both']);

var timeType = exports.timeType = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]);

var componentType = exports.componentType = _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]);